import { FieldGroupEnum } from "@/graphql/codegen/graphql"
import colors from "@/styles/colors"

export enum ProductFileType {
  COA = "PRODUCT_COA",
  COO = "PRODUCT_COO",
  Labwork = "PRODUCT_LABWORK",
  Miscellaneous = "MISCELLANEOUS",
  SDS = "PRODUCT_SDS",
  TDS = "PRODUCT_TDS",
}

export const FileTypeToChipColorMap: Record<ProductFileType, { label: string; color: string }> = {
  [FieldGroupEnum.ProductCoa]: {
    label: "COA",
    color: colors.tertiary.purple["100"],
  },
  [FieldGroupEnum.ProductCoo]: {
    label: "COO",
    color: colors.secondary["200"],
  },
  [FieldGroupEnum.ProductLabwork]: {
    label: "Labwork",
    color: colors.tertiary.yellow["100"],
  },
  [FieldGroupEnum.Miscellaneous]: {
    label: "Miscellaneous",
    color: colors.tertiary.green["300"],
  },
  [FieldGroupEnum.ProductSds]: {
    label: "SDS",
    color: colors.primary["200"],
  },
  [FieldGroupEnum.ProductTds]: {
    label: "TDS",
    color: colors.tertiary.orange["300"],
  },
}
